export const MS_TEAM_CHAT = 'https://teams.microsoft.com/l/chat/0/0?users='
export const MS_TEAM_CALL = 'https://teams.microsoft.com/l/call/0/0?users='
export const MAIL_TO = 'mailto:'
